import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const RepeatIcon = ({
  width = 40,
  height = 40,
  stroke = '#fff',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="repeat">
      <path
        id="Vector"
        d="M31 11.9996V17.9996M31 17.9996H25M31 17.9996L26.36 13.6396C25.2853 12.5643 23.9556 11.7788 22.4952 11.3564C21.0348 10.9339 19.4911 10.8883 18.0083 11.2238C16.5255 11.5594 15.1518 12.265 14.0155 13.275C12.8791 14.285 12.0172 15.5664 11.51 16.9996M9 27.9996V21.9996M9 21.9996H15M9 21.9996L13.64 26.3596C14.7147 27.4349 16.0444 28.2204 17.5048 28.6428C18.9652 29.0652 20.5089 29.1108 21.9917 28.7753C23.4745 28.4398 24.8482 27.7342 25.9845 26.7242C27.1209 25.7142 27.9828 24.4328 28.49 22.9996"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
